module.exports = __webpack_public_path__ + "img/079e4c3.png";